import Modal from "../../../components/Modal/Modal";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import Textarea from "../../../components/Textarea/Textarea";
import PropTypes from "prop-types";
import { useMemo } from "react";
import Button from "../../../components/Button/Button";

const meetingModeOptions = [
  { id: 1, name: "In Person" },
  { id: 2, name: "Online" },
  { id: 3, name: "Phone" },
];

const statusOptions = [
  { id: 2, name: "Confirm" },
  { id: 5, name: "Reschedule" },
  { id: 4, name: "Cancel" },
];

const AppointmentReplyForm = ({
  isModalOpen = false,
  closeModal = () => {},
  formData = {
    meeting_date: "",
    meeting_time: "",
    meeting_mode: "",
    status: "",
    reply_notes: "",
  },
  handleChange = () => {},
  handleSave = () => {},
  isSubmitting = false,
}) => {
  const { meeting_date, meeting_time, meeting_mode, status, reply_notes } =
    formData;

  // Validation and error state
  const errors = useMemo(
    () => ({
      meeting_date: !meeting_date,
      meeting_time: !meeting_time,
      meeting_mode: !meeting_mode,
      status: !status,
    }),
    [meeting_date, meeting_time, meeting_mode, status],
  );

  const isSaveDisabled = useMemo(
    () =>
      isSubmitting ||
      errors.meeting_date ||
      errors.meeting_time ||
      errors.meeting_mode ||
      errors.status,
    [isSubmitting, errors],
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={closeModal}
      title="Reply Appointment"
      size="md"
    >
      {/* Meeting Date */}
      <div className="form-group mb-3">
        <Input
          label={"Meeting Date"}
          id="meeting_date"
          type="date"
          name="meeting_date"
          required={true}
          value={meeting_date || ""}
          onChange={handleChange}
          className="form-control"
          aria-invalid={errors.meeting_date}
        />
        {errors.meeting_date && (
          <small className="text-danger">Meeting date is required.</small>
        )}
      </div>

      {/* Meeting Time */}
      <div className="form-group mb-3">
        <Input
          label={"Meeting Time"}
          id="meeting_time"
          type="time"
          name="meeting_time"
          required={true}
          value={meeting_time || ""}
          onChange={handleChange}
          className="form-control"
          aria-invalid={errors.meeting_time}
        />
        {errors.meeting_time && (
          <small className="text-danger">Meeting time is required.</small>
        )}
      </div>

      {/* Meeting Mode */}
      <div className="form-group mb-3">
        <Select
          label={"Meeting Mode"}
          id="meeting_mode"
          name="meeting_mode"
          required={true}
          value={meeting_mode || ""}
          onChangeHandler={handleChange}
          placeholder="Select Mode"
          options={meetingModeOptions}
          aria-invalid={errors.meeting_mode}
        />
        {errors.meeting_mode && (
          <small className="text-danger">Meeting mode is required.</small>
        )}
      </div>

      {/* Status */}
      <div className="form-group mb-3">
        <Select
          label={"Status"}
          id="status"
          name="status"
          required={true}
          value={status || ""}
          onChangeHandler={handleChange}
          placeholder="Select Status"
          options={statusOptions}
          aria-invalid={errors.status}
        />
        {errors.status && (
          <small className="text-danger">Status is required.</small>
        )}
      </div>

      {/* Reply Notes */}
      <div className="form-group mb-3">
        <Textarea
          label={"Reply Notes"}
          id="reply_notes"
          name="reply_notes"
          value={reply_notes || ""}
          onChange={handleChange}
          className="form-control"
          rows="3"
          placeholder="Enter reply notes"
        />
      </div>

      {/* Footer Buttons */}
      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="secondary"
          onClick={closeModal}
          disabled={isSubmitting}
          type="button"
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={handleSave}
          disabled={isSaveDisabled}
          type="button"
          aria-busy={isSubmitting}
        >
          {isSubmitting ? (
            <span>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Saving...
            </span>
          ) : (
            "Save"
          )}
        </Button>
      </div>
    </Modal>
  );
};

AppointmentReplyForm.propTypes = {
  closeModal: PropTypes.func,
  formData: PropTypes.object,
  handleChange: PropTypes.func,
  handleSave: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

export default AppointmentReplyForm;
